import { Directive, Input } from '@angular/core';

import { handleDropdownMenuContainerKeydown, showDropdownAndFocusMenuItem } from 'app/shared/utils/dropdown-menu-keyboard.util';

import { BaseControlDirective } from './base-control.directive';

@Directive()
export abstract class CommonDropdownControlDirective<TItem, TValue> extends BaseControlDirective<TValue> {
  private static nextId = 0;

  private readonly dropdownId = CommonDropdownControlDirective.nextId++;
  private selectedItemField: TItem | undefined;

  public readonly buttonId = `common-dropdown-button-${this.dropdownId}`;
  public readonly menuId = `common-dropdown-menu-${this.dropdownId}`;

  @Input() public placeholder = '';
  @Input() public disabled = false;
  @Input() public testId = '';
  @Input() public items!: TItem[];
  @Input() public getName!: (item: TItem) => string | undefined;
  @Input() public getValue: (item: TItem) => TValue = (item) => item as unknown as TValue;

  public get selectedItem(): TItem | undefined {
    return this.selectedItemField;
  }

  public onItemClick(item: TItem): void {
    this.writeValue(this.getValue(item));
  }

  public modelChanged(): void {
    super.modelChanged();
    if (this.items) {
      this.selectedItemField = this.items.find((item) => this.getValue(item) === this.model);
    }
  }

  public resolveName(item: TItem | unknown): string {
    return item ? this.getName(item as TItem) ?? '' : this.placeholder;
  }

  public onToggleArrowKeydown(event: KeyboardEvent, dropdown: { show(): void }, focusLastItem: boolean): void {
    showDropdownAndFocusMenuItem(event, () => dropdown.show(), focusLastItem);
  }

  public onMenuKeydown(event: KeyboardEvent, dropdown: { hide(): void }, toggleButton: HTMLElement): void {
    handleDropdownMenuContainerKeydown(event, () => dropdown.hide(), toggleButton);
  }
}
